import React from "react";
import { Text, View } from "react-native";

function ScheduleEmptyState({
  message,
}: {
  message: string;
}) {
  return (
    <View className="mx-5 px-4 py-10 bg-teachLoop-creamDark rounded-2xl">
      <Text className="font-geologica-regular text-center text-base text-gray-800 leading-[1.5]">
        {message}
      </Text>
    </View>
  );
}

export default ScheduleEmptyState;

